import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { useTranslation } from 'react-i18next';

export default function LegalLink() {
  const { i18n } = useTranslation();
  const label = i18n.language?.startsWith('de')
    ? 'Impressum / Datenschutz / Rechtliches'
    : 'Legal Notice / Privacy / Legal Terms';

  return (
    <MuiLink
      component={RouterLink}
      to="/legal"
      underline="hover"
      variant="caption"
      color="text.secondary"
      sx={{ position: 'fixed', bottom: 12, right: 16, zIndex: 1 }}
    >
      {label}
    </MuiLink>
  );
}
